import { Header } from "~/components/landing-page/header";
import { api } from "~/utils/api";
import Head from "next/head";
import ArticleCard from "~/components/marketing/article-card";
import { type GetServerSideProps } from "next";
import { db } from "~/server/db";
import { type RouterOutputs } from "~/utils/api";
import { Mixpanel } from "~/components/tracking-provider";

export const OMIT_BOARD_IDS = ["837951143108068536", "837951143108072809"];

type InspirationPageProps = {
  data: RouterOutputs["pinterest"]["getBoardNamesFromDb"];
};

const Page = ({ data }: InspirationPageProps) => {
  const { data: mostRecentImagesPerBoard } =
    api.pinterest.getMostRecentImagesPerBoard.useQuery({
      boardIds: data?.map((board) => board.board_id),
    });

  console.log(mostRecentImagesPerBoard);

  return (
    <div>
      <Head>
        <title>Glimpses AI Outfit Inspiration</title>
      </Head>

      <Header />

      <div className="mx-auto max-w-5xl p-8">
        <h1 className="text-3xl font-bold">Inspiration</h1>
        <div className="mt-6 grid grid-cols-1 items-center gap-4 md:grid-cols-2">
          {mostRecentImagesPerBoard &&
            data?.map((collection, i) => (
              <div
                key={collection.id}
                onClick={() => {
                  Mixpanel.track("Button Click", {
                    section: "Inspiration",
                    button: collection.name,
                  });
                }}
              >
                <ArticleCard
                  title={collection.name}
                  date={collection.updated_at.toDateString()}
                  image={mostRecentImagesPerBoard[i]!}
                  link={`/inspiration/${collection.slug_name}`}
                  author="Nihir Vedd"
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=3600, stale-while-revalidate=86400",
  );

  const data = await db.pinterestBoards.findMany();

  console.log("data here", data);

  if (!data) {
    return { props: { data: null } };
  }

  const relevantBoards = data?.filter(
    (board) => !OMIT_BOARD_IDS.includes(board.board_id),
  );

  console.log("relevantBoards", relevantBoards);

  return {
    props: {
      data: relevantBoards,
    },
  };
};

export default Page;
